import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { StatusCode } from "../../components/Alert.tsx";
import FeedbacksController from '../../controllers/FeedbacksController.ts';
import { Feedback } from '../../models/feedbacks/feedback.ts';
import { useAlert } from "../alertProvider.tsx";

type FeedbackContextType = {
    isLoaded?: boolean;
    feedback: Feedback;
    insertFeedback: (entity: Feedback) => void;
    updateFeedback: (entity: Feedback) => void;
}

const FeedbackContext = createContext<FeedbackContextType>({} as FeedbackContextType);

export const FeedbackContextProvider = ({ children, id }: { children: any, id: any }) => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [feedback, setFeedback] = useState<Feedback>({ feedbackID: 0, name: '', description: '', } as Feedback);
    const { showAlert } = useAlert();
    const navigate = useNavigate();

    const getFeedbackByID = async () => {
        if (id == "create") { setIsLoaded(true); return; }
        try {
            const result = await FeedbacksController.getByID(id);
            if (result.notificationStatus == StatusCode.success)
                setFeedback(result);
            else showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error fetching feedback:', error);
        } finally {
            setIsLoaded(true);
        }
    }

    const insertFeedback = async (entity: Feedback) => {
        try {
            const result = await FeedbacksController.post(entity);
            if (result.notificationStatus == StatusCode.success)
                navigate(-1);
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error inserting feedback:', error);
        }
    }

    const updateFeedback = async (entity: Feedback) => {
        try {
            const result = await FeedbacksController.put(entity);
            if (result.notificationStatus == StatusCode.success)
                navigate(-1);
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error updating feedback:', error);
        }
    }

    useEffect(() => {
        getFeedbackByID();
    }, [id]);

    const context: FeedbackContextType = {
        isLoaded,
        feedback,
        insertFeedback,
        updateFeedback
    }

    return (
        <FeedbackContext.Provider value={context}>
            {children}
        </FeedbackContext.Provider>
    )
}

export const useFeedbackContext = () => useContext(FeedbackContext);